import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import './logout.css';
import { useTranslation } from 'react-i18next';


const Logout = ({isLoggedIn, setIsLoggedIn}) => {
  const navigate = useNavigate();

  const { t } = useTranslation('global');

  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('pagePermissions');
    setIsLoggedIn(false);
    navigate('/login');
  };

  return (
      <Button className="logout-button" onClick={handleLogout} title="Logout">
        {t('logout.logout')}
      </Button>
  );
};

export default Logout;